import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import SpaceListPage from './pages/SpaceListPage';
import SpaceDetailPage from './pages/SpaceDetailPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import BookingPage from './pages/BookingPage';
import './App.css';

function App() {
  const [authToken, setAuthToken] = React.useState(localStorage.getItem('token'));
  const [userType, setUserType] = React.useState(localStorage.getItem('userType'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    setAuthToken(null);
    setUserType(null);
  };

  return (
    <Router>
      <Navigation authToken={authToken} userType={userType} onLogout={handleLogout} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/spaces" element={<SpaceListPage />} />
        <Route path="/spaces/:id" element={<SpaceDetailPage />} />
        <Route path="/auth" element={<AuthPage setAuthToken={setAuthToken} setUserType={setUserType} />} />
        <Route path="/dashboard" element={authToken ? <DashboardPage userType={userType} /> : <Navigate to="/auth" />} />
        <Route path="/booking/:spaceId" element={authToken ? <BookingPage /> : <Navigate to="/auth" />} />
      </Routes>
    </Router>
  );
}

export default App;
